import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Historia from "@/components/Historia";
import Servicios from "@/components/Servicios";
import AntesDespues from "@/components/AntesDespues";
import Galeria from "@/components/Galeria";
import Testimonios from "@/components/Testimonios";
import Presupuestos from "@/components/Presupuestos";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App bg-bg text-white min-h-screen antialiased">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Historia />
          <Servicios />
          <AntesDespues />
          <Galeria />
          <Testimonios />
          <Presupuestos />
          <Contacto />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-center" theme="dark" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
